import i18n from '@/i18n'

export const commonOptions_es = {

    data() {
        return { 

            es: {
            
                sexOptions: [
                    { value: 'M', text: 'Masculino' },
                    { value: 'F', text: 'Hembra' },
                    { value: 'O', text: 'No binario' },
                    { value: 'U', text: 'Prefiero no decirlo' },
                ],

                raceOptions: [
                    { value: 'W', text: 'Blanco' },
                    { value: 'B', text: 'Negro' },
                    { value: 'A', text: 'Asiático' },
                    { value: 'P', text: 'Nativa de Hawaii / Pacífico' },
                    { value: 'I', text: 'Indio Americano Nativo de Alaska /' },
                    { value: 'O', text: 'Otro' },
                    { value: 'U', text: 'Desconocido' },
                ],

                livingOptions: [
                    { value: '1', text: 'Residencia privada' },
                    { value: '11', text: 'Hotel / motel' },
                    { value: '2', text: 'Centro de cuidados a largo plazo, centro de rehabilitación o centro de asistencia' },
                    { value: '9', text: 'Hogar de grupo o centro de salud del comportamiento' },
                    { value: '5', text: 'Un refugio para personas sin hogar' },
                    { value: '12', text: 'Actualmente no protegido y sin hogar' },
                    { value: '6', text: 'La cárcel / prisión' },
                    { value: '7', text: 'Colegio / Universidad / dormitorio Campo' },
                    { value: '10', text: 'Dormitorio de trabajo' },
                    { value: '8', text: 'Otro' },
                ],

                contactSettingOptions: [
                    { value: 'H', text: 'Centro de salud' },
                    { value: 'N', text: 'Hogar de ancianos, centro de atención a largo plazo, centro de rehabilitación, o una instalación de tipo similar' },
                    { value: 'G', text: 'Hogar de grupo o centro de tipo similar' },
                    { value: 'C', text: 'Instalación correccional' },
                    { value: 'S', text: 'Refugio para personas sin hogar' }
                ],

                eventOptions: [
                    { value: '1', text: 'Servicio de iglesia' },
                    { value: '2', text: 'Festival o feria' },
                    { value: '3', text: 'Evento deportivo' },
                    { value: '4', text: 'Reunión de la familia / fiestas' },
                    { value: '5', text: 'Concierto' },
                    { value: '6', text: 'Boda' },
                    { value: '7', text: 'Funeraria / vigilia' },
                    { value: '8', text: 'Fiesta en la calle' },
                    { value: '9', text: 'Otro' }
                ],

                yesNoOptions: [
                    { value: 'Y', text: 'Si' },
                    { value: 'N', text: 'No' },            
                ],

                symptomYesNoOptions: [
                    { value: 'Y', text: 'Si, He tenido síntomas' },
                    { value: 'N', text: 'No, No he tenido ningún síntoma' },            
                ],

                yesNoUnknownOptions: [
                    { value: 'Y', text: 'Si' },
                    { value: 'N', text: 'No' },
                    { value: 'U', text: "Desconocido" },            
                ],

                yesNoUnknownNaOptions: [
                    { value: 'Y', text: 'Si' },
                    { value: 'N', text: 'No' },
                    { value: 'U', text: "Desconocido" },
                    { value: 'X', text: "No aplica" },            
                ],

                covid19Symptoms: [
                    'Fiebre',
                    'Tos',
                    'Dificultad para respirar',
                    'Pérdida del sentido del gusto o el olfato',
                    'Fatiga',
                    'Dolor de cabeza',
                    'Dolores musculares',
                    'Diarrea',
                    'Náuseas o vómitos'
                ],

                workplaceSettings: [
                    { value: 'HEALTHCARE', text: 'El establecimiento como un hospital o clínica de atención de la salud' },
                    { value: 'LTC', text: 'El cuidado a largo plazo, de vida asistida o residencia de ancianos' },
                    { value: 'RES_TREAT', text: 'El abuso de sustancias y el programa de tratamiento de pacientes hospitalizados' },
                    { value: 'GROUP_HOME', text: 'Hogar de grupo'},
                    { value: 'CORRECTIONS', text: 'Correccional como una prisión o cárcel'},
                    { value: 'CHILDCARE', text: 'Centro de cuidado de niños o cuidado de niños en el hogar'},
                    { value: 'K12', text: 'Colegio'},
                    { value: 'COLLEGE_UNIV', text: 'Colegio, universidad u otra institución de educación superior'},
                    { value: 'SPORTS', text: 'Deportes organizados'},
                    { value: 'OTHER', text: 'Otro'}
                ],

                hcwRoleOptions: [
                    { value: '1', text: 'Physician'},
                    { value: '2', text: 'Nurse'},
                    { value: '6', text: 'CNA (Certified Nursing Assistant)'},
                    { value: '7', text: 'PCA (Patient Care Assistant)'},
                    { value: '3', text: 'Respiratory Therapist'},
                    { value: '4', text: 'Environmental Services (e.g., housekeeping, cleaning staff)'},
                    { value: '5', text: 'Other'},
                ]
            }
        }
    },
}